module.exports = __webpack_public_path__ + "img/font.5a6a13f8.svg";